import { useQuery } from "@tanstack/react-query";
import { matchPath } from "react-router";
import { useCurrentEmployeeRequest } from "~api/employees.ts";
import { featuresQueryOptions } from "~api/features.ts";
import { useCurrentEmployeeTenants } from "~api/tenants.ts";
import { ROUTES } from "~components/routeDefinitions.ts";

function tenantNumberFromPathname(pathname: string) {
  return matchPath({ path: ROUTES.dashboard.path, end: false }, pathname)
    ?.params.tenantNumber;
}

export function GateQueriesPreloader({ pathname }: { pathname: string }) {
  useCurrentEmployeeRequest();
  const { data: tenants } = useCurrentEmployeeTenants();

  const tenantNumber = tenantNumberFromPathname(pathname);
  const tenant =
    tenants?.find(({ number }) => String(number) === tenantNumber) ??
    tenants?.[0];

  return tenant ? <FeaturesPreloader tenantId={tenant.id} /> : null;
}

function FeaturesPreloader({ tenantId }: { tenantId: string }) {
  useQuery(featuresQueryOptions(tenantId));
  return null;
}
